(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fundraiser-signup-form"] && !window.DesignMode) return;
  try {
    
  const form = document.getElementById('FundraiserForm');
  const customerTagsInput = document.getElementById('FundraiserSignupForm-tags');
  const affiliateInput = document.getElementById('FundraiserSignupForm-affiliate');
  const affiliateDatalist = document.getElementById('FundraiserSignupForm-affiliates');
  const returnTo = document.querySelector('#FundraiserForm > [name="return_to"]');
  let affiliates = [];

  function getCustomerAffiliateTag(rfsnParameterValue) {
    const [_, value] = rfsnParameterValue.slice('1').split('=')
    return `AFFILIATE:${value}`;
  }

  async function generateAffiliateSelector() {
    const response = await fetch(`${EXTERNAL_API_BASE_URL}/affiliates`).then(function(res) {
      return res.json()
    });
    affiliates = response.data.affiliates.sort((a, b) => {
      if (a.name < b.name)
        return -1;
      if (a.name > b.name)
        return 1;
      return 0;
    });

    affiliateDatalist.innerHTML = "";

    for (let i = 0; i < affiliates.length; i++) {
      const affiliate = affiliates[i];
      const option = document.createElement('option');
      option.setAttribute('value', affiliate.name);
      option.setAttribute('data-value', getCustomerAffiliateTag(affiliate.rfsn_parameter));
      option.setAttribute('data-parameter', affiliate.rfsn_parameter);

      affiliateDatalist.appendChild(option);
    }

    // Check if there is a autovalue on search params that we can auto select
    const searchParams = new URLSearchParams(window.location.search)
    const rfsn = searchParams.get('rfsn');
    if (rfsn) {
      const defaultAffiliateId = rfsn.split('.')[0];
      const affiliateFound = affiliates.find((a) => String(a.id) === defaultAffiliateId);
      if (affiliateFound) {
        affiliateInput.value = affiliateFound.name;
        // This is required to update the form value
        affiliateInput.dispatchEvent(new Event('change'));
      }
    }
  }
  
  affiliateInput.addEventListener("change", function(event) {
    const affiliateName = event.target.value;
    const affiliateSelected = affiliates.find((affiliate) => affiliate.name === affiliateName);
    
    if (affiliateSelected) {
      // Update "customer[tags]""
      customerTagsInput.value = getCustomerAffiliateTag(affiliateSelected.rfsn_parameter);
      // This is required to update the form value
      customerTagsInput.dispatchEvent(new Event('change'));

      // Update "return_to"
      const [key, value] = affiliateSelected.rfsn_parameter.slice(1).split('=')
      // const url = new URL(returnTo.value);
      // url.searchParams.set(key, value);
      // returnTo.value = url.toString();
      // This is required to update the form value
      // returnTo.dispatchEvent(new Event('change'));
    } else {
      // Reset return_to & customer[tags]
      
      // Update "customer[tags]""
      customerTagsInput.value = '';
      // This is required to update the form value
      customerTagsInput.dispatchEvent(new Event('change'));

      // Update "return_to"
      const url = new URL(returnTo.value);
      url.searchParams.delete('rfsn');
      returnTo.value = url.toString();
      // This is required to update the form value
      returnTo.dispatchEvent(new Event('change'));
    }
  });

  affiliateInput.addEventListener('blur', function(event) {
    if (event.target.value !== '' && (customerTagsInput.value == null | customerTagsInput.value === '')) {
      event.target.value = ''
      event.target.dispatchEvent(new Event('change'));
    }
  });

  // TODO: remove this
  // form.addEventListener('submit', function(event) {
  //     const formData = new FormData(event.target);
  //     const email = formData.get('customer[email]');
  //     const cutomerTags = formData.get('customer[tags]');
  //     const [id, code] = cutomerTags.split(':')[1].split('.');

  //     registerEmailWithAffiliate(email, id, code);
  //     return true;
  // });

  generateAffiliateSelector();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
